import { useEffect, useState } from "react";
import Swal, { SweetAlertOptions } from "sweetalert2";
import { IconContext } from "react-icons";
import { MdShare, MdContentCopy, MdCheck, MdStop, MdPhonelinkOff } from "react-icons/md";
import { FaSpinner } from "react-icons/fa";
import { toast } from "react-toastify";
import { CopyToClipboard } from "react-copy-to-clipboard";
import IconButton from "~/shared/IconButton";
import api from "~/adapters/api";
import { SharedContainer } from "./styles";

type ShareGalleryProps = {
    jobId: number;
    galleryShareToken?: string;
};

const ShareGallery = ({ jobId, galleryShareToken }: ShareGalleryProps) => {
    const [loading, setLoading] = useState(false);
    const [shareToken, setShareToken] = useState("");
    const [copied, setCopied] = useState(false);

    useEffect(() => {
        setShareToken(galleryShareToken ?? "");
        setCopied(false);
    }, [galleryShareToken]);

    const createNewSharing = () => {
        setLoading(true);
        api.jobs.galleries.share({ jobId })
            .then(({ token }) => {
                setShareToken(token);
                setCopied(false);
            })
            .catch(e => {
                toast.error(`Não foi possível compartilhar a galeria: ${e?.response?.data?.msg ?? e.message}`);
            })
            .finally(() => setLoading(false));
    };

    const sharedGalleryUrl = (token: string) => {
        return `${process.env.NEXT_PUBLIC_SELF_URL}/gallery/s/${token}`;
    };

    const copyText = () => {
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 5000);
    }

    const removeSharing = () => {
        const params: SweetAlertOptions = {
            title: "Deseja remover o compartilhamento?",
            text: "Ao remover o compartilhamento este link será perdido e os usuários não poderão mais acessar esta galeria.",
            icon: "warning",
            confirmButtonColor: "#DD6B55",
            showCancelButton: true,
            confirmButtonText: "Remover",
            cancelButtonText: "Sair",
            showLoaderOnConfirm: true,
            preConfirm: async () => {
                return api.jobs.galleries.unshare({ jobId })
                    .then(() => setShareToken(null))
                    .catch(e => {
                        toast.error(`Não foi possível remover o compartilhamento: ${e?.message?.response?.data ?? e.message}`);
                    });
            }
        };

        Swal.fire(params);
    };

    return (
        <>
            {shareToken ? (
                <SharedContainer>
                    <input type="text" readOnly value={sharedGalleryUrl(shareToken)} className="form-control" />
                    <CopyToClipboard text={sharedGalleryUrl(shareToken)} onCopy={copyText}>
                        <button className="copy" type="button" title="Copiar link">
                            {copied ? <MdCheck /> : <MdContentCopy />}
                        </button>
                    </CopyToClipboard>
                        <button
                            className="unlink"
                            type="button"
                            title="Remover compartilhamento"
                            onClick={removeSharing}
                        >
                            <MdPhonelinkOff />
                        </button>
                </SharedContainer>
            ) : (
                <IconButton onClick={createNewSharing} disabled={loading} Icon={() => <MdShare size={16} style={{ marginTop: "7px" }} />}>
                    {loading ? (
                        <IconContext.Provider value={{ size: "16px", className: "spin" }}>
                            <FaSpinner />
                        </IconContext.Provider>
                    ) : (
                        "Compartilhar"
                    )}
                </IconButton>
            )}
        </>

    );
};

export default ShareGallery;
